/**
 * @file 消耗总览
 * @author lanistzhang
 */

import _ from 'lodash';
import React from 'react';
import { Button } from '@tencent/spaui';
import Icon from '@tencent/od-icon';

import { DeskAnnouncementContent } from '@/pages/agency/notice/DeskAnnouncement';
import globalStore from '@/stores';

import HomeItem, { HomeRowWrapper } from '../home-item';
import FastEntry, { FastEntryProps } from './fast-entry';
import MonitorNotice from '@/pages/agency/account/monitor/entry/notice';
import { hasFeatureFlagSuper, hasPurview } from '@/services';

interface AnnouncementEntryProps {
  fastEntry: FastEntryProps;
}

/**
 * 公告 + 常用入口
 */
const AnnouncementEntry: React.FC<AnnouncementEntryProps> = (props) => {
  const { fastEntry } = props;
  const { history } = globalStore;

  return (
    <HomeRowWrapper>
      {hasPurview(210) && <HomeItem
        header={(
          <>
            <div className="title">监控预警</div>
            <div className="right">
              <Button
                className="more"
                displayType="link"
                endIcon={<Icon name="right-outlined" />}
                data-report="home-jump-monitor-more"
                onClick={() => history.push('/agency/monitor/manage')}
              >
                监控管理
              </Button>
            </div>
          </>
        )}
      >
        <MonitorNotice />
      </HomeItem>}
      <HomeItem
        header={(
          <>
            <div className="title">常用入口</div>
            <div className="right">
              <Button
                className="more"
                displayType="link"
                endIcon={<Icon name="right-outlined" />}
                data-report="home-jump-toolbox-more"
                onClick={() => history.push('/agency/manage/toolbox')}
              >
                更多
              </Button>
            </div>
          </>
        )}
      >
        <FastEntry {...fastEntry} />
      </HomeItem>
      <HomeItem
        header={(
          <>
            <div className="title">公告</div>
            <div className="right">
              <Button
                className="more"
                displayType="link"
                endIcon={<Icon name="right-outlined" />}
                data-report="home-jump-notice-more"
                onClick={() => history.push('/agency/notice')}
              >
                更多
              </Button>
            </div>
          </>
        )}
      >
        <DeskAnnouncementContent />
      </HomeItem>
    </HomeRowWrapper>
  );
};

export default AnnouncementEntry;
